






















































import Vue from 'vue'

import {State} from '@/store'
import easyapi from '@/easyapi'
import DeviceTypeIcon from '@/components/DeviceTypeIcon.vue'
import DeviceVendorIcon from '@/components/DeviceVendorIcon.vue'
import HpdIcon from '@/components/HpdIcon.vue'
import AliveIndicator from '@/components/AliveIndicator.vue'
import PreviewScreen from '@/components/PreviewScreen.vue'
import { PropValidator, RenderContext } from 'vue/types/options'
import { vuetifyThemeAware } from '@/mixins'
import mixins from 'vue-typed-mixins'
import { IDevice } from '@/types/model'
import { dev_property_t, thumb_size_t, DeviceListPref } from '@/store/modules/pref'
import moment from 'moment'
export default mixins(vuetifyThemeAware).extend({
  components: {
    DeviceTypeIcon,
    DeviceVendorIcon,
    AliveIndicator,
    PreviewScreen,
    HpdIcon,
  },
  computed: {
    devices (): IDevice[] { return this.$s.$state.device.list },
    pref (): DeviceListPref { return this.$s.$state.pref.deviceList },
  },
  methods: {
    blinkLed (device: IDevice): void { easyapi.blinkLed(this, device) },
    openDeviceInfoDialog (device: IDevice): void {
      this.$router.push({ name: 'devlst_details', params: {master_mac: device.mac} })
    },
    openDeviceRenameDialog (device: IDevice): void {
      this.$router.push({ name: 'devlst_rename', params: {mac: device.mac} })
    },
    rightSideInfo (device: IDevice): string {
      if (this.pref.showingField === 'connectionTime') {
        return this.$filters.durSecToHuman(device.connectionTime)
      }
      return device[this.pref.showingField].toString()
    },
    canBlinkLed (dev: IDevice): boolean {
      return dev.online && dev.vendor === 'Aspeed'
    }
  }
})
